import { PublicPage } from 'api/website';
import { isDefined } from 'utils/functional';

import { getContentHasBackground } from './getContentHasBackground';
import { getIsContentFullWidthLayout } from './getIsContentFullWidthLayout';
import { getLastNonScollTrackingContentBlock } from './getLastNonScollTrackingContentBlock';

type Props = {
  content: PublicPage;
};

export function getHideFooterDivider({ content }: Props) {
  const lastBlock = getLastNonScollTrackingContentBlock({ content });
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    isDefined(lastBlock) &&
    ((lastBlock.type === 'SPLIT_CONTENT' &&
      lastBlock.data.appearance === 'FULL_WIDTH' &&
      fullWidthLayout) ||
      [
        'GRAD_CTA_HERO',
        'CTA_HERO',
        'STICKY_HEADER_LINKS_GRAD',
        'STICKY_HEADER_LINKS',
        'SCROLL_TRACKING',
      ].includes(lastBlock.type) ||
      getContentHasBackground({
        block: lastBlock,
        fullWidthLayout,
      }))
  );
}
